import { render, staticRenderFns } from "./BitrixIcon.vue?vue&type=template&id=6b3f2d3c&scoped=true"
import script from "./BitrixIcon.vue?vue&type=script&lang=js"
export * from "./BitrixIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f2d3c",
  null
  
)

export default component.exports